export const hasSeenEstimates = (): boolean => {
  const value = localStorage.getItem('hasSeenEstimates');

  return value ? JSON.parse(value) : false;
};

export const setHasSeenEstimates = (hasSeen: boolean): void => {
  localStorage.setItem('hasSeenEstimates', JSON.stringify(hasSeen));
};

export const isCurrentEstimatesSession = (): boolean => {
  const value = sessionStorage.getItem('isCurrentEstimatesSession');

  return value ? JSON.parse(value) : false;
};

export const setIsCurrentEstimatesSession = (isCurrent: boolean): void => {
  sessionStorage.setItem('isCurrentEstimatesSession', JSON.stringify(isCurrent));
};
